import { render, staticRenderFns } from "./SBImageContent.html?vue&type=template&id=3183699a&scoped=true&"
import script from "./SBImageContent.ts?vue&type=script&lang=ts&"
export * from "./SBImageContent.ts?vue&type=script&lang=ts&"
import style0 from "./SBImageContent.css?vue&type=style&index=0&id=3183699a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3183699a",
  null
  
)

export default component.exports